import data from './_data';
import methods from './_methods';
import props from './_props';

export default {
    name: 'TableExportIcon',
    data,
    methods,
    props
};
